module.exports = __webpack_public_path__ + "static/media/paintbrush-green.9153e347.png";